export const gateway_colors = [
    {
      "nikobizz etr": {
        "light": {
          "primary": "#348EC9",
          "surfaceTint": "#2A638A",
          "onPrimary": "#FFFFFF",
          "primaryContainer": "#CBE6FF",
          "onPrimaryContainer": "#001E31",
          "secondary": "#50606F",
          "onSecondary": "#FFFFFF",
          "secondaryContainer": "#D4E4F6",
          "onSecondaryContainer": "#0D1D2A",
          "tertiary": "#66587B",
          "onTertiary": "#FFFFFF",
          "tertiaryContainer": "#ECDCFF",
          "onTertiaryContainer": "#211534",
          "error": "#BA1A1A",
          "onError": "#FFFFFF",
          "errorContainer": "#FFDAD6",
          "onErrorContainer": "#410002",
          "background": "#F7F9FF",
          "onBackground": "#181C20",
          "surface": "#F7F9FF",
          "onSurface": "#181C20",
          "surfaceVariant": "#DEE3EA",
          "onSurfaceVariant": "#42474D",
          "outline": "#72787E",
          "outlineVariant": "#C1C7CE",
          "shadow": "#000000",
          "scrim": "#000000",
          "inverseSurface": "#2D3135",
          "inverseOnSurface": "#EEF1F6",
          "inversePrimary": "#98CCF9",
          "primaryFixed": "#CBE6FF",
          "onPrimaryFixed": "#001E31",
          "primaryFixedDim": "#98CCF9",
          "onPrimaryFixedVariant": "#034B71",
          "secondaryFixed": "#D4E4F6",
          "onSecondaryFixed": "#0D1D2A",
          "secondaryFixedDim": "#B8C8D9",
          "onSecondaryFixedVariant": "#394856",
          "tertiaryFixed": "#ECDCFF",
          "onTertiaryFixed": "#211534",
          "tertiaryFixedDim": "#D1BFE7",
          "onTertiaryFixedVariant": "#4E4162",
          "surfaceDim": "#D7DADF",
          "surfaceBright": "#F7F9FF",
          "surfaceContainerLowest": "#FFFFFF",
          "surfaceContainerLow": "#F1F4F9",
          "surfaceContainer": "#EBEEF3",
          "surfaceContainerHigh": "#E6E8EE",
          "surfaceContainerHighest": "#E0E3E8"
        },
        "dark": {
          "primary": "#98CCF9",
          "surfaceTint": "#98CCF9",
          "onPrimary": "#003350",
          "primaryContainer": "#034B71",
          "onPrimaryContainer": "#CBE6FF",
          "secondary": "#B8C8D9",
          "onSecondary": "#22323F",
          "secondaryContainer": "#394856",
          "onSecondaryContainer": "#D4E4F6",
          "tertiary": "#D1BFE7",
          "onTertiary": "#372B4A",
          "tertiaryContainer": "#4E4162",
          "onTertiaryContainer": "#ECDCFF",
          "error": "#FFB4AB",
          "onError": "#690005",
          "errorContainer": "#93000A",
          "onErrorContainer": "#FFDAD6",
          "background": "#101417",
          "onBackground": "#E0E3E8",
          "surface": "#101417",
          "onSurface": "#E0E3E8",
          "surfaceVariant": "#42474D",
          "onSurfaceVariant": "#C1C7CE",
          "outline": "#8C9198",
          "outlineVariant": "#42474D",
          "shadow": "#000000",
          "scrim": "#000000",
          "inverseSurface": "#E0E3E8",
          "inverseOnSurface": "#2D3135",
          "inversePrimary": "#2A638A",
          "primaryFixed": "#CBE6FF",
          "onPrimaryFixed": "#001E31",
          "primaryFixedDim": "#98CCF9",
          "onPrimaryFixedVariant": "#034B71",
          "secondaryFixed": "#D4E4F6",
          "onSecondaryFixed": "#0D1D2A",
          "secondaryFixedDim": "#B8C8D9",
          "onSecondaryFixedVariant": "#394856",
          "tertiaryFixed": "#ECDCFF",
          "onTertiaryFixed": "#211534",
          "tertiaryFixedDim": "#D1BFE7",
          "onTertiaryFixedVariant": "#4E4162",
          "surfaceDim": "#101417",
          "surfaceBright": "#363A3E",
          "surfaceContainerLowest": "#0B0F12",
          "surfaceContainerLow": "#181C20",
          "surfaceContainer": "#1C2024",
          "surfaceContainerHigh": "#272A2E",
          "surfaceContainerHighest": "#313539"
        }
      },
      "nikobizz mobile": {
        "light": {
          "primary": "#348EC9",
          "surfaceTint": "#2A638A",
          "onPrimary": "#FFFFFF",
          "primaryContainer": "#CBE6FF",
          "onPrimaryContainer": "#001E31",
          "secondary": "#50606F",
          "onSecondary": "#FFFFFF",
          "secondaryContainer": "#D4E4F6",
          "onSecondaryContainer": "#0D1D2A",
          "tertiary": "#66587B",
          "onTertiary": "#FFFFFF",
          "tertiaryContainer": "#ECDCFF",
          "onTertiaryContainer": "#211534",
          "error": "#BA1A1A",
          "onError": "#FFFFFF",
          "errorContainer": "#FFDAD6",
          "onErrorContainer": "#410002",
          "background": "#F7F9FF",
          "onBackground": "#181C20",
          "surface": "#F7F9FF",
          "onSurface": "#181C20",
          "surfaceVariant": "#DEE3EA",
          "onSurfaceVariant": "#42474D",
          "outline": "#72787E",
          "outlineVariant": "#C1C7CE",
          "shadow": "#000000",
          "scrim": "#000000",
          "inverseSurface": "#2D3135",
          "inverseOnSurface": "#EEF1F6",
          "inversePrimary": "#98CCF9",
          "primaryFixed": "#CBE6FF",
          "onPrimaryFixed": "#001E31",
          "primaryFixedDim": "#98CCF9",
          "onPrimaryFixedVariant": "#034B71",
          "secondaryFixed": "#D4E4F6",
          "onSecondaryFixed": "#0D1D2A",
          "secondaryFixedDim": "#B8C8D9",
          "onSecondaryFixedVariant": "#394856",
          "tertiaryFixed": "#ECDCFF",
          "onTertiaryFixed": "#211534",
          "tertiaryFixedDim": "#D1BFE7",
          "onTertiaryFixedVariant": "#4E4162",
          "surfaceDim": "#D7DADF",
          "surfaceBright": "#F7F9FF",
          "surfaceContainerLowest": "#FFFFFF",
          "surfaceContainerLow": "#F1F4F9",
          "surfaceContainer": "#EBEEF3",
          "surfaceContainerHigh": "#E6E8EE",
          "surfaceContainerHighest": "#E0E3E8"
        },
        "dark": {
          "primary": "#98CCF9",
          "surfaceTint": "#98CCF9",
          "onPrimary": "#003350",
          "primaryContainer": "#034B71",
          "onPrimaryContainer": "#CBE6FF",
          "secondary": "#B8C8D9",
          "onSecondary": "#22323F",
          "secondaryContainer": "#394856",
          "onSecondaryContainer": "#D4E4F6",
          "tertiary": "#D1BFE7",
          "onTertiary": "#372B4A",
          "tertiaryContainer": "#4E4162",
          "onTertiaryContainer": "#ECDCFF",
          "error": "#FFB4AB",
          "onError": "#690005",
          "errorContainer": "#93000A",
          "onErrorContainer": "#FFDAD6",
          "background": "#101417",
          "onBackground": "#E0E3E8",
          "surface": "#101417",
          "onSurface": "#E0E3E8",
          "surfaceVariant": "#42474D",
          "onSurfaceVariant": "#C1C7CE",
          "outline": "#8C9198",
          "outlineVariant": "#42474D",
          "shadow": "#000000",
          "scrim": "#000000",
          "inverseSurface": "#E0E3E8",
          "inverseOnSurface": "#2D3135",
          "inversePrimary": "#2A638A",
          "primaryFixed": "#CBE6FF",
          "onPrimaryFixed": "#001E31",
          "primaryFixedDim": "#98CCF9",
          "onPrimaryFixedVariant": "#034B71",
          "secondaryFixed": "#D4E4F6",
          "onSecondaryFixed": "#0D1D2A",
          "secondaryFixedDim": "#B8C8D9",
          "onSecondaryFixedVariant": "#394856",
          "tertiaryFixed": "#ECDCFF",
          "onTertiaryFixed": "#211534",
          "tertiaryFixedDim": "#D1BFE7",
          "onTertiaryFixedVariant": "#4E4162",
          "surfaceDim": "#101417",
          "surfaceBright": "#363A3E",
          "surfaceContainerLowest": "#0B0F12",
          "surfaceContainerLow": "#181C20",
          "surfaceContainer": "#1C2024",
          "surfaceContainerHigh": "#272A2E",
          "surfaceContainerHighest": "#313539"
        }
      },
      "nenasasa":{
        "light": {
            "primary": "#282460",
            "surfaceTint": "#5B5891",
            "onPrimary": "#FFFFFF",
            "primaryContainer": "#E3DFFF",
            "onPrimaryContainer": "#17134A",
            "secondary": "#5E5C71",
            "onSecondary": "#FFFFFF",
            "secondaryContainer": "#E4E0F9",
            "onSecondaryContainer": "#1B1A2C",
            "tertiary": "#7A5367",
            "onTertiary": "#FFFFFF",
            "tertiaryContainer": "#FFD8E9",
            "onTertiaryContainer": "#2F1123",
            "error": "#BA1A1A",
            "onError": "#FFFFFF",
            "errorContainer": "#FFDAD6",
            "onErrorContainer": "#410002",
            "background": "#FCF8FF",
            "onBackground": "#1C1B20",
            "surface": "#FCF8FF",
            "onSurface": "#1C1B20",
            "surfaceVariant": "#E5E1EC",
            "onSurfaceVariant": "#47464F",
            "outline": "#787680",
            "outlineVariant": "#C8C5D0",
            "shadow": "#000000",
            "scrim": "#000000",
            "inverseSurface": "#313036",
            "inverseOnSurface": "#F3EFF7",
            "inversePrimary": "#C4C0FF",
            "primaryFixed": "#E3DFFF",
            "onPrimaryFixed": "#17134A",
            "primaryFixedDim": "#C4C0FF",
            "onPrimaryFixedVariant": "#434078",
            "secondaryFixed": "#E4E0F9",
            "onSecondaryFixed": "#1B1A2C",
            "secondaryFixedDim": "#C7C4DC",
            "onSecondaryFixedVariant": "#464559",
            "tertiaryFixed": "#FFD8E9",
            "onTertiaryFixed": "#2F1123",
            "tertiaryFixedDim": "#EBB9D0",
            "onTertiaryFixedVariant": "#603B4F",
            "surfaceDim": "#DCD8E0",
            "surfaceBright": "#FCF8FF",
            "surfaceContainerLowest": "#FFFFFF",
            "surfaceContainerLow": "#F6F2FA",
            "surfaceContainer": "#F0ECF4",
            "surfaceContainerHigh": "#EBE7EF",
            "surfaceContainerHighest": "#E5E1E9"
        },
        "dark": {
            "primary": "#C4C0FF",
            "surfaceTint": "#C4C0FF",
            "onPrimary": "#2D2960",
            "primaryContainer": "#434078",
            "onPrimaryContainer": "#E3DFFF",
            "secondary": "#C7C4DC",
            "onSecondary": "#302E42",
            "secondaryContainer": "#464559",
            "onSecondaryContainer": "#E4E0F9",
            "tertiary": "#EBB9D0",
            "onTertiary": "#472638",
            "tertiaryContainer": "#603B4F",
            "onTertiaryContainer": "#FFD8E9",
            "error": "#FFB4AB",
            "onError": "#690005",
            "errorContainer": "#93000A",
            "onErrorContainer": "#FFDAD6",
            "background": "#131318",
            "onBackground": "#E5E1E9",
            "surface": "#131318",
            "onSurface": "#E5E1E9",
            "surfaceVariant": "#47464F",
            "onSurfaceVariant": "#C8C5D0",
            "outline": "#928F99",
            "outlineVariant": "#47464F",
            "shadow": "#000000",
            "scrim": "#000000",
            "inverseSurface": "#E5E1E9",
            "inverseOnSurface": "#313036",
            "inversePrimary": "#5B5891",
            "primaryFixed": "#E3DFFF",
            "onPrimaryFixed": "#17134A",
            "primaryFixedDim": "#C4C0FF",
            "onPrimaryFixedVariant": "#434078",
            "secondaryFixed": "#E4E0F9",
            "onSecondaryFixed": "#1B1A2C",
            "secondaryFixedDim": "#C7C4DC",
            "onSecondaryFixedVariant": "#464559",
            "tertiaryFixed": "#FFD8E9",
            "onTertiaryFixed": "#2F1123",
            "tertiaryFixedDim": "#EBB9D0",
            "onTertiaryFixedVariant": "#603B4F",
            "surfaceDim": "#131318",
            "surfaceBright": "#3A383F",
            "surfaceContainerLowest": "#0E0E13",
            "surfaceContainerLow": "#1C1B20",
            "surfaceContainer": "#201F25",
            "surfaceContainerHigh": "#2A292F",
            "surfaceContainerHighest": "#35343A"
        },
      },
        "nenacall": {
          "light": {
              "primary": "#1800AD",
            "surfaceTint": "#4C49D7",
            "onPrimary": "#FFFFFF",
            "primaryContainer": "#1800AD",
            "onPrimaryContainer": "#8E8EFF",
            "secondary": "#585993",
            "onSecondary": "#FFFFFF",
            "secondaryContainer": "#BEBEFF",
            "onSecondaryContainer": "#4A4B84",
            "tertiary": "#370044",
            "onTertiary": "#FFFFFF",
            "tertiaryContainer": "#59006C",
            "onTertiaryContainer": "#CF7ADE",
            "error": "#BA1A1A",
            "onError": "#FFFFFF",
            "errorContainer": "#FFDAD6",
            "onErrorContainer": "#93000A",
            "background": "#FCF8FF",
            "onBackground": "#1B1B23",
            "surface": "#FCF8FF",
            "onSurface": "#1B1B23",
            "surfaceVariant": "#E3E0F3",
            "onSurfaceVariant": "#464554",
            "outline": "#777586",
            "outlineVariant": "#C7C4D7",
            "shadow": "#000000",
            "scrim": "#000000",
            "inverseSurface": "#302F39",
            "inverseOnSurface": "#F2EFFB",
            "inversePrimary": "#C1C1FF",
            "primaryFixed": "#E2DFFF",
            "onPrimaryFixed": "#0A006B",
            "primaryFixedDim": "#C1C1FF",
            "onPrimaryFixedVariant": "#322CBF",
            "secondaryFixed": "#E2DFFF",
            "onSecondaryFixed": "#14134B",
            "secondaryFixedDim": "#C1C1FF",
            "onSecondaryFixedVariant": "#404179",
            "tertiaryFixed": "#FED6FF",
            "onTertiaryFixed": "#350041",
            "tertiaryFixedDim": "#F6ADFF",
            "onTertiaryFixedVariant": "#712183",
            "surfaceDim": "#DBD8E4",
            "surfaceBright": "#FCF8FF",
            "surfaceContainerLowest": "#FFFFFF",
            "surfaceContainerLow": "#F5F2FE",
            "surfaceContainer": "#EFECF8",
            "surfaceContainerHigh": "#EAE6F3",
            "surfaceContainerHighest": "#E4E1ED"
          },
          "dark": {
            "primary": "#C1C1FF",
            "surfaceTint": "#C1C1FF",
            "onPrimary": "#1700A7",
            "primaryContainer": "#C1C1FF",
            "onPrimaryContainer": "#8E8EFF",
            "secondary": "#C1C1FF",
            "onSecondary": "#2A2A61",
            "secondaryContainer": "#43437C",
            "onSecondaryContainer": "#B3B2F3",
            "tertiary": "#F6ADFF",
            "onTertiary": "#560068",
            "tertiaryContainer": "#59006C",
            "onTertiaryContainer": "#CF7ADE",
            "error": "#FFB4AB",
            "onError": "#690005",
            "errorContainer": "#93000A",
            "onErrorContainer": "#FFDAD6",
            "background": "#13131B",
            "onBackground": "#E4E1ED",
            "surface": "#13131B",
            "onSurface": "#E4E1ED",
            "surfaceVariant": "#464554",
            "onSurfaceVariant": "#C7C4D7",
            "outline": "#918FA0",
            "outlineVariant": "#464554",
            "shadow": "#000000",
            "scrim": "#000000",
            "inverseSurface": "#E4E1ED",
            "inverseOnSurface": "#302F39",
            "inversePrimary": "#4C49D7",
            "primaryFixed": "#E2DFFF",
            "onPrimaryFixed": "#0A006B",
            "primaryFixedDim": "#C1C1FF",
            "onPrimaryFixedVariant": "#322CBF",
            "secondaryFixed": "#E2DFFF",
            "onSecondaryFixed": "#14134B",
            "secondaryFixedDim": "#C1C1FF",
            "onSecondaryFixedVariant": "#404179",
            "tertiaryFixed": "#FED6FF",
            "onTertiaryFixed": "#350041",
            "tertiaryFixedDim": "#F6ADFF",
            "onTertiaryFixedVariant": "#712183",
            "surfaceDim": "#13131B",
            "surfaceBright": "#393841",
            "surfaceContainerLowest": "#0D0D15",
            "surfaceContainerLow": "#1B1B23",
            "surfaceContainer": "#1F1F27",
            "surfaceContainerHigh": "#2A2932",
            "surfaceContainerHighest": "#34343D"
          }
      },
      "nenachat": {
  "light": {
    "primary": "#1800AD",
    "surfaceTint": "#585992",
    "onPrimary": "#FFFFFF",
    "primaryContainer": "#E2E0F9",
    "onPrimaryContainer": "#414178",
    "secondary": "#5D5C72",
    "onSecondary": "#FFFFFF",
    "secondaryContainer": "#E2E0F9",
    "onSecondaryContainer": "#454559",
    "tertiary": "#795369",
    "onTertiary": "#FFFFFF",
    "tertiaryContainer": "#FFD8EB",
    "onTertiaryContainer": "#5F3C51",
    "error": "#BA1A1A",
    "onError": "#FFFFFF",
    "errorContainer": "#FFDAD6",
    "onErrorContainer": "#93000A",
    "background": "#FCF8FF",
    "onBackground": "#1B1B21",
    "surface": "#FCF8FF",
    "onSurface": "#1B1B21",
    "surfaceVariant": "#E4E1EC",
    "onSurfaceVariant": "#47464F",
    "outline": "#777680",
    "outlineVariant": "#C8C5D0",
    "shadow": "#000000",
    "scrim": "#000000",
    "inverseSurface": "#303036",
    "inverseOnSurface": "#F3EFF7",
    "inversePrimary": "#C1C1FF",
    "primaryFixed": "#E2DFFF",
    "onPrimaryFixed": "#14134A",
    "primaryFixedDim": "#C1C1FF",
    "onPrimaryFixedVariant": "#414178",
    "secondaryFixed": "#E2E0F9",
    "onSecondaryFixed": "#1A1A2C",
    "secondaryFixedDim": "#C6C4DD",
    "onSecondaryFixedVariant": "#454559",
    "tertiaryFixed": "#FFD8EB",
    "onTertiaryFixed": "#2F1124",
    "tertiaryFixedDim": "#E9B9D2",
    "onTertiaryFixedVariant": "#5F3C51",
    "surfaceDim": "#DCD9E0",
    "surfaceBright": "#FCF8FF",
    "surfaceContainerLowest": "#FFFFFF",
    "surfaceContainerLow": "#F6F2FA",
    "surfaceContainer": "#F0ECF4",
    "surfaceContainerHigh": "#EAE7EF",
    "surfaceContainerHighest": "#E4E1E9"
  },
  "dark": {
    "primary": "#C1C1FF",
    "surfaceTint": "#C1C1FF",
    "onPrimary": "#2A2A60",
    "primaryContainer": "#414178",
    "onPrimaryContainer": "#E2DFFF",
    "secondary": "#C6C4DD",
    "onSecondary": "#2F2F42",
    "secondaryContainer": "#454559",
    "onSecondaryContainer": "#E2E0F9",
    "tertiary": "#E9B9D2",
    "onTertiary": "#46263A",
    "tertiaryContainer": "#5F3C51",
    "onTertiaryContainer": "#FFD8EB",
    "error": "#FFB4AB",
    "onError": "#690005",
    "errorContainer": "#93000A",
    "onErrorContainer": "#FFDAD6",
    "background": "#131318",
    "onBackground": "#E4E1E9",
    "surface": "#131318",
    "onSurface": "#E4E1E9",
    "surfaceVariant": "#47464F",
    "onSurfaceVariant": "#C8C5D0",
    "outline": "#918F98",
    "outlineVariant": "#47464F",
    "shadow": "#000000",
    "scrim": "#000000",
    "inverseSurface": "#E4E1E9",
    "inverseOnSurface": "#303036",
    "inversePrimary": "#585992",
    "primaryFixed": "#E2DFFF",
    "onPrimaryFixed": "#14134A",
    "primaryFixedDim": "#C1C1FF",
    "onPrimaryFixedVariant": "#414178",
    "secondaryFixed": "#E2E0F9",
    "onSecondaryFixed": "#1A1A2C",
    "secondaryFixedDim": "#C6C4DD",
    "onSecondaryFixedVariant": "#454559",
    "tertiaryFixed": "#FFD8EB",
    "onTertiaryFixed": "#2F1124",
    "tertiaryFixedDim": "#E9B9D2",
    "onTertiaryFixedVariant": "#5F3C51",
    "surfaceDim": "#131318",
    "surfaceBright": "#39383F",
    "surfaceContainerLowest": "#0E0E13",
    "surfaceContainerLow": "#1B1B21",
    "surfaceContainer": "#1F1F25",
    "surfaceContainerHigh": "#2A2930",
    "surfaceContainerHighest": "#35343B"
  }
},
        "default": {
          "light": {
              "primary": "#0c0070",
              "surfaceTint": "#4c49d7",
              "onPrimary": "#ffffff",
              "primaryContainer": "#bebeff",
              "onPrimaryContainer": "#8e8eff",
              "secondary": "#585993",
              "onSecondary": "#ffffff",
              "secondaryContainer": "#bebeff",
              "onSecondaryContainer": "#4a4b84",
              "tertiary": "#370044",
              "onTertiary": "#ffffff",
              "tertiaryContainer": "#59006c",
              "onTertiaryContainer": "#cf7ade",
              "error": "#ba1a1a",
              "onError": "#ffffff",
              "errorContainer": "#ffdad6",
              "onErrorContainer": "#93000a",
              "background": "#fcf8ff",
              "onBackground": "#1b1b23",
              "surface": "#fcf8ff",
              "onSurface": "#1b1b23",
              "surfaceVariant": "#e3e0f3",
              "onSurfaceVariant": "#464554",
              "outline": "#777586",
              "outlineVariant": "#c7c4d7",
              "shadow": "#000000",
              "scrim": "#000000",
              "inverseSurface": "#303039",
              "inverseOnSurface": "#f2effb",
              "inversePrimary": "#c1c1ff",
              "primaryFixed": "#e2dfff",
              "onPrimaryFixed": "#0a006b",
              "primaryFixedDim": "#c1c1ff",
              "onPrimaryFixedVariant": "#322cbf",
              "secondaryFixed": "#e2dfff",
              "onSecondaryFixed": "#14134b",
              "secondaryFixedDim": "#c1c1ff",
              "onSecondaryFixedVariant": "#404179",
              "tertiaryFixed": "#fed6ff",
              "onTertiaryFixed": "#350041",
              "tertiaryFixedDim": "#f6adff",
              "onTertiaryFixedVariant": "#712183",
              "surfaceDim": "#dbd8e4",
              "surfaceBright": "#fcf8ff",
              "surfaceContainerLowest": "#ffffff",
              "surfaceContainerLow": "#f5f2fe",
              "surfaceContainer": "#efecf8",
              "surfaceContainerHigh": "#eae6f3",
              "surfaceContainerHighest": "#e4e1ed"
          },
          "dark": {
              "primary": "#c1c1ff",
              "surfaceTint": "#c1c1ff",
              "onPrimary": "#1700a7",
              "primaryContainer": "#1800ad",
              "onPrimaryContainer": "#8e8eff",
              "secondary": "#c1c1ff",
              "onSecondary": "#2a2a61",
              "secondaryContainer": "#43437c",
              "onSecondaryContainer": "#b3b2f3",
              "tertiary": "#f6adff",
              "onTertiary": "#560068",
              "tertiaryContainer": "#59006c",
              "onTertiaryContainer": "#cf7ade",
              "error": "#ffb4ab",
              "onError": "#690005",
              "errorContainer": "#93000a",
              "onErrorContainer": "#ffdad6",
              "background": "#13131b",
              "onBackground": "#e4e1ed",
              "surface": "#13131b",
              "onSurface": "#e4e1ed",
              "surfaceVariant": "#464554",
              "onSurfaceVariant": "#c7c4d7",
              "outline": "#918fa0",
              "outlineVariant": "#464554",
              "shadow": "#000000",
              "scrim": "#000000",
              "inverseSurface": "#e4e1ed",
              "inverseOnSurface": "#303039",
              "inversePrimary": "#4c49d7",
              "primaryFixed": "#e2dfff",
              "onPrimaryFixed": "#0a006b",
              "primaryFixedDim": "#c1c1ff",
              "onPrimaryFixedVariant": "#322cbf",
              "secondaryFixed": "#e2dfff",
              "onSecondaryFixed": "#14134b",
              "secondaryFixedDim": "#c1c1ff",
              "onSecondaryFixedVariant": "#404179",
              "tertiaryFixed": "#fed6ff",
              "onTertiaryFixed": "#350041",
              "tertiaryFixedDim": "#f6adff",
              "onTertiaryFixedVariant": "#712183",
              "surfaceDim": "#13131b",
              "surfaceBright": "#393841",
              "surfaceContainerLowest": "#0d0d15",
              "surfaceContainerLow": "#1b1b23",
              "surfaceContainer": "#1f1f27",
              "surfaceContainerHigh": "#2a2932",
              "surfaceContainerHighest": "#34343d"
          }
      }
    }
  ];
  